module.exports = __webpack_public_path__ + "img/First.621fcb8a.svg";